//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// See https://isotope.metafizzy.co/extras.html#webpack

import Isotope from 'isotope-layout';
import * as $ from 'jquery';
import jQueryBridget from 'jquery-bridget';

// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );
